import { BROADCAST_CLEAR_DIRECTOR_REQUEST } from '../Types';

function clearDirectorRequest(request) {
  return dispatch => {
    const action = {
      type: BROADCAST_CLEAR_DIRECTOR_REQUEST,
      payload: request
    };
    dispatch(action);
  };
}

export default clearDirectorRequest;
